import { Box } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

export const ScheduleIcon = ({
  withDot = false,
  iconColor = 'var(--fgPrimary)',
  dotColor = 'var(--accent)',
  size = '24px',
}: {
  withDot?: boolean;
  iconColor?: string;
  dotColor?: string;
  size?: string;
}) => {
  return withDot ? (
    <Box position="relative">
      <Icon
        name={iconNames.scheduleWithMessages}
        fill={iconColor}
        width={size}
        height={size}
      />
      <Box position="absolute" right="1px" top="1px">
        <Box bg={dotColor} borderRadius="50%" width={1.5} height={1.5} />
      </Box>
    </Box>
  ) : (
    <Icon
      name={iconNames.schedule}
      fill={iconColor}
      width={size}
      height={size}
    />
  );
};
